module.exports = __webpack_public_path__ + "assets/default.4dd8f730.svg";